export const LIST_REPORTS = 'LIST_REPORTS';
export const LIST_SCHEDULED = 'LIST_SCHEDULED';
export const LIST_REPORT_LOG = 'LIST_REPORT_LOG';
export const RUN_REPORT = 'RUN_REPORT';
export const CREATE_SCHEDULE_REPORT = 'CREATE_SCHEDULE_REPORT';
export const UPDATE_SCHEDULE_REPORT = 'UPDATE_SCHEDULE_REPORT';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const SET_CURRENT = 'SET_CURRENT';
export const DOWNLOAD_REPORT = 'DOWNLOAD_REPORT';
